<template>
  <el-dialog
    :visible.sync="showDialog"
    :title="title"
    width="480px">
    <div class="content">
      {{ content }}
      <slot name="content"/>
    </div>
    <button class="footer-btn" name="footer" @click="showDialog = false">
      {{ btnContent }}
    </button>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false
    };
  },
  props: ['title', 'content', 'btnContent'],
  methods: {
    open() {
      this.showDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  border-radius: 10px;

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 0 12px;
    font-size: 16px;
    text-align: left;
    background: #F7F7F7;
    border-radius: 10px 10px 0 0;

    .el-dialog__headerbtn {
      position: static;
    }

    .el-dialog__close::before {
      font-size: 24px;
    }
  }

  .el-dialog__body {
    padding: 0 30px 12px;
  }
}

.content {
  line-height: 20px;
  padding: 20px 0;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  text-align: center;
}

.footer-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 36px;
  margin: 0 auto;
  font-size: 14px;
  font-weight: bolder;
  color: #FFFFFF;
  background: #08A681;
  border-radius: 4px;
}
</style>
